import Vue from 'vue'

Vue.filter('img', (url, width = 640) => {
  return `${url}?imageView2/0/w/${width}`
})